const Close = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 2.92492L21.075 1L12 10.0746L2.925 1L1 2.92492L10.075 11.9995L1 21.0742L2.925 22.9991L12 13.9245L21.075 22.9991L23 21.0742L13.925 11.9995L23 2.92492Z"
      fill="black"
    />
  </svg>
);

export default Close;
